import { TranslationMap } from '@trimble-gcs/i18n-types';

export function connect3dPanelTranslations() {
  return {
    fileStatus: {
      checkingStatus: {
        text: $localize`:@@connect3dPanel.fileStatus.checkingStatus:Checking status...`,
        desc: 'Message displayed while retrieving the tiling status of a file.',
      },
      regionNotSupported: {
        text: $localize`:@@connect3dPanel.fileStatus.regionNotSupported:Region not supported.`,
        desc: 'Message displayed when the project region is not supported.',
      },
      ingestionError: {
        text: $localize`:@@connect3dPanel.fileStatus.ingestionError:Error. Click to refresh.`,
        desc: 'Message displayed when there was an error getting the file status.',
      },
      quotaExceeded: {
        text: $localize`:@@connect3dPanel.fileStatus.quotaExceeded:Quota exceeded.`,
        desc: 'Message displayed when the account storage quota has been exceeded.',
      },
      quotaWillBeExceeded: {
        text: $localize`:@@connect3dPanel.fileStatus.quotaWillBeExceeded:Quota will be exceeded.`,
        desc: 'Message displayed when the account storage quota will be exceeded if tiling the file.',
      },
      readyToRefresh: {
        text: $localize`:@@connect3dPanel.fileStatus.readyToRefresh:Busy tiling. Click to refresh.`,
        desc: 'Message displayed when the file is being tiled and the user can refresh to update the status.',
      },
      tiling: {
        text: $localize`:@@connect3dPanel.fileStatus.tiling:Tiling...`,
        desc: 'Message displayed while the file is being tiled.',
      },
      tilingError: {
        text: $localize`:@@connect3dPanel.fileStatus.tilingError:Tiling error.`,
        desc: 'Message displayed when there was an error tiling the file.',
      },
      insufficientPermission: {
        text: $localize`:@@connect3dPanel.fileStatus.insufficientPermission:Insufficient permission to tile this file.`,
        desc: 'Message displayed when the user does not have sufficient permissions to tile the file.',
      },
      noActiveLicense: {
        text: $localize`:@@connect3dPanel.fileStatus.noActiveLicense:No active license for project.`,
        desc: 'Message displayed when there is no active license for the Connect project.',
      },
    },
  } satisfies TranslationMap;
}
